import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  InputGroup,
  Badge,
  Spinner,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import {
  FaBan,
  FaCheck,
  FaPlus,
  FaSearch,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaFilePdf,
} from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import history from '~/Config/history';
import * as api from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { abrirPdfEmNovaAba } from '~/Utils/Helpers';
import { caracteristicas } from '~/constant';

var opcoesFiltroStatus = [
  { value: 'ativos', label: 'Ativos' },
  { value: 'inativos', label: 'Inativos' },
  { value: 'todos', label: 'Todos' },
];

// W-0608: opções do filtro de Validade (espelha Delphi UConusuario.pas — RadioGroup2).
const opcoesFiltroValidade = [
  { value: 'todos', label: 'Todos' },
  { value: 'vencidos', label: 'Vencidos' },
  { value: 'avencer', label: 'A vencer' },
];

var ITENS_POR_PAGINA = 50;

var Usuarios = function () {
  var _useState = function (val) { return useState(val); };

  var usuariosState = _useState([]);
  var usuarios = usuariosState[0]; var setUsuarios = usuariosState[1];
  var loadingState = _useState(true);
  var loading = loadingState[0]; var setLoading = loadingState[1];
  var filtroState = _useState('');
  var filtro = filtroState[0]; var setFiltro = filtroState[1];
  var filtroTimerRef = useRef(null);
  var statusFiltroState = _useState('ativos');
  var statusFiltro = statusFiltroState[0]; var setStatusFiltro = statusFiltroState[1];

  // W-0608: filtro de Validade
  const validadeFiltroState = _useState('todos');
  const validadeFiltro = validadeFiltroState[0]; const setValidadeFiltro = validadeFiltroState[1];

  // W-0608: estado do export PDF
  const exportandoState = _useState(false);
  const exportando = exportandoState[0]; const setExportando = exportandoState[1];

  // Ordenação
  var ordenacaoState = _useState({ campo: 'nome', direcao: 'asc' });
  var ordenacao = ordenacaoState[0]; var setOrdenacao = ordenacaoState[1];

  // Paginação
  var paginaState = _useState(1);
  var pagina = paginaState[0]; var setPagina = paginaState[1];

  // Modal ativar/inativar
  var showStatusModalState = _useState(false);
  var showStatusModal = showStatusModalState[0]; var setShowStatusModal = showStatusModalState[1];
  var usuarioAlvoState = _useState(null);
  var usuarioAlvo = usuarioAlvoState[0]; var setUsuarioAlvo = usuarioAlvoState[1];
  var loadingStatusState = _useState(false);
  var loadingStatus = loadingStatusState[0]; var setLoadingStatus = loadingStatusState[1];

  var temPermissao = AuthStorage.temCaracteristica(caracteristicas.ManutencaoUsuario);
  // W-0608: 661 (SomenteConsultaUsuarios) amplia a visão — vê todos os usuários sem filtro de grupo.
  const temSomenteConsulta = AuthStorage.temCaracteristica(caracteristicas.SomenteConsultaUsuarios);
  const apenasCorretor = !temPermissao && !temSomenteConsulta && AuthStorage.temCaracteristica(caracteristicas.VisualizaUsuarioCorretor);
  var gruposPermitidos = [195, 197, 214];
  var isGrupoTI = AuthStorage.isGrupoTI();

  var handleOrdenacao = function (campo) {
    setOrdenacao(function (prev) {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  var iconeOrdenacao = function (campo) {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  var thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  const carregarUsuarios = async (status, validade) => {
    setLoading(true);
    try {
      const res = await api.obterUsuarios({ status, validade });
      setUsuarios(res || []);
    } catch (e) {
      toast.error('Erro ao carregar a lista de usuários');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { carregarUsuarios(statusFiltro, validadeFiltro); }, [statusFiltro, validadeFiltro]);

  // W-0608: handler do botão Exportar PDF.
  // Abre a aba sincronamente no click (antes do await) pra não cair em popup blocker.
  const handleExportarPdf = async () => {
    const janelaPreAberta = window.open('', '_blank');
    if (!janelaPreAberta) {
      toast.error('Popup bloqueado — habilite popups deste site pra abrir o PDF');
      return;
    }
    setExportando(true);
    try {
      const blob = await api.exportarUsuariosPdf({
        status: statusFiltro,
        validade: validadeFiltro,
      });
      abrirPdfEmNovaAba(blob, janelaPreAberta);
    } catch (e) {
      janelaPreAberta.close();
      const msg = (e && e.message) || 'Erro ao gerar PDF — tente novamente';
      toast.error(msg);
    } finally {
      setExportando(false);
    }
  };

  var handleAlterarStatus = function (usuario) {
    setUsuarioAlvo(usuario);
    setShowStatusModal(true);
  };

  var handleConfirmarAlteracaoStatus = async function () {
    if (!usuarioAlvo) return;
    var estaAtivo = usuarioAlvo.status !== 1;
    setLoadingStatus(true);
    try {
      if (estaAtivo) {
        await api.inativarUsuarioAdmin(usuarioAlvo.codigo);
        toast.success('Usuário inativado com sucesso!');
      } else {
        await api.ativarUsuarioAdmin(usuarioAlvo.codigo);
        toast.success('Usuário ativado com sucesso!');
      }
      setShowStatusModal(false);
      setUsuarioAlvo(null);
      await carregarUsuarios(statusFiltro, validadeFiltro);
    } catch (e) {
      var msg = (e && e.message) || 'Erro ao alterar status do usuário';
      toast.error(msg);
    } finally {
      setLoadingStatus(false);
    }
  };

  var dadosFiltrados = usuarios.filter(function (u) {
    if (apenasCorretor && gruposPermitidos.indexOf(u.codigo_grupo) < 0) return false;
    if (!filtro) return true;
    var termo = filtro.toLowerCase();
    return (u.nome || '').toLowerCase().indexOf(termo) >= 0
      || (u.email || '').toLowerCase().indexOf(termo) >= 0
      || (u.nome_usuario || '').toLowerCase().indexOf(termo) >= 0
      || String(u.codigo).indexOf(termo) >= 0;
  }).sort(function (a, b) {
    var campo = ordenacao.campo;
    var dir = ordenacao.direcao === 'asc' ? 1 : -1;
    var valA = campo === 'departamento_descricao' ? (a.departamento && a.departamento.descricao || '') : a[campo];
    var valB = campo === 'departamento_descricao' ? (b.departamento && b.departamento.descricao || '') : b[campo];
    if (valA == null) valA = '';
    if (valB == null) valB = '';
    // W-0608: ordenação por data_hora_expiracao (data) e nome_grupo (string).
    if (campo === 'data_hora_expiracao') {
      const dA = valA ? new Date(valA).getTime() : 0;
      const dB = valB ? new Date(valB).getTime() : 0;
      return dir * (dA - dB);
    }
    if (campo === 'nome' || campo === 'email' || campo === 'nome_usuario' || campo === 'departamento_descricao' || campo === 'nome_grupo') {
      return dir * String(valA).toLowerCase().localeCompare(String(valB).toLowerCase());
    }
    return dir * (Number(valA) - Number(valB));
  });

  var totalPaginas = Math.ceil(dadosFiltrados.length / ITENS_POR_PAGINA) || 1;
  var dadosPaginados = dadosFiltrados.slice((pagina - 1) * ITENS_POR_PAGINA, pagina * ITENS_POR_PAGINA);

  if (loading) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .usuarios-desktop { display: block; }\
        .usuarios-mobile  { display: none; }\
        @media (max-width: 768px) {\
          .usuarios-desktop { display: none !important; }\
          .usuarios-mobile  { display: block; }\
          .usuarios-filtro-row { flex-direction: column; }\
          .usuarios-filtro-row > [class*="col"] { margin-bottom: 8px; flex: 0 0 100%; max-width: 100%; }\
          .usuarios-filtro-row .text-right { text-align: right !important; }\
        }\
      '}</style>

      <Header title="Cadastro de Usuários" />

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-end usuarios-filtro-row">
            <Col md={4}>
              <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 500 }}>Buscar</Form.Label>
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text><FaSearch /></InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Nome, email, login ou código..."
                  defaultValue=""
                  onChange={function (e) {
                    var val = e.target.value;
                    if (filtroTimerRef.current) clearTimeout(filtroTimerRef.current);
                    filtroTimerRef.current = setTimeout(function () {
                      setFiltro(val);
                      setPagina(1);
                    }, 300);
                  }}
                />
              </InputGroup>
            </Col>
            <Col md={2}>
              <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 500 }}>Status</Form.Label>
              <Form.Control
                as="select"
                size="sm"
                value={statusFiltro}
                onChange={function (e) { setStatusFiltro(e.target.value); setPagina(1); setFiltro(''); }}
              >
                {opcoesFiltroStatus.map(function (o) {
                  return <option key={o.value} value={o.value}>{o.label}</option>;
                })}
              </Form.Control>
            </Col>
            {/* W-0608: filtro de Validade */}
            <Col md={2}>
              <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 500 }}>Validade</Form.Label>
              <Form.Control
                as="select"
                size="sm"
                value={validadeFiltro}
                onChange={function (e) { setValidadeFiltro(e.target.value); setPagina(1); }}
              >
                {opcoesFiltroValidade.map(function (o) {
                  return <option key={o.value} value={o.value}>{o.label}</option>;
                })}
              </Form.Control>
            </Col>
            <Col md={4} className="text-right">
              {/* W-0608: botão Exportar PDF — disabled quando lista vazia ou export em andamento */}
              <Button
                size="sm"
                variant="outline-primary"
                className="mr-2"
                onClick={handleExportarPdf}
                disabled={exportando || dadosFiltrados.length === 0}
                title={dadosFiltrados.length === 0 ? 'Sem registros para exportar' : 'Exportar listagem em PDF'}
              >
                {exportando ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" className="mr-1" /> Gerando PDF…
                  </>
                ) : (
                  <>
                    <FaFilePdf className="mr-1" /> Exportar PDF
                  </>
                )}
              </Button>
              {temPermissao && isGrupoTI && (
                <Button size="sm" variant="success" onClick={function () { history.push('/usuarios/novo'); }}>
                  <FaPlus className="mr-1" /> Novo Usuário
                </Button>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Usuários
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({dadosFiltrados.length} {dadosFiltrados.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {dadosFiltrados.length === 0 ? (
            <p className="text-muted text-center my-4">
              {filtro ? 'Nenhum usuário encontrado para o filtro informado.' : 'Nenhum usuário encontrado.'}
            </p>
          ) : (
            <>
              {/* Desktop */}
              <div className="usuarios-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th style={Object.assign({ width: '70px' }, thSortStyle)} onClick={function () { handleOrdenacao('codigo'); }}>#{iconeOrdenacao('codigo')}</th>
                      <th style={Object.assign({}, thSortStyle)} onClick={function () { handleOrdenacao('nome'); }}>Nome{iconeOrdenacao('nome')}</th>
                      <th style={Object.assign({ width: '220px' }, thSortStyle)} onClick={function () { handleOrdenacao('email'); }}>Email{iconeOrdenacao('email')}</th>
                      <th style={Object.assign({ width: '130px' }, thSortStyle)} onClick={function () { handleOrdenacao('nome_usuario'); }}>Login{iconeOrdenacao('nome_usuario')}</th>
                      {/* W-0608: coluna Validade (data_hora_expiracao formatada) */}
                      <th style={Object.assign({ width: '110px' }, thSortStyle)} onClick={function () { handleOrdenacao('data_hora_expiracao'); }}>Validade{iconeOrdenacao('data_hora_expiracao')}</th>
                      {/* W-0608: coluna Grupo */}
                      <th style={Object.assign({ width: '160px' }, thSortStyle)} onClick={function () { handleOrdenacao('nome_grupo'); }}>Grupo{iconeOrdenacao('nome_grupo')}</th>
                      <th style={Object.assign({ width: '150px' }, thSortStyle)} onClick={function () { handleOrdenacao('departamento_descricao'); }}>Departamento{iconeOrdenacao('departamento_descricao')}</th>
                      <th style={Object.assign({ width: '100px', textAlign: 'center' }, thSortStyle)} onClick={function () { handleOrdenacao('status'); }}>Status{iconeOrdenacao('status')}</th>
                      {temPermissao && <th style={{ width: '80px', textAlign: 'center' }}>Ações</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {dadosPaginados.map(function (u) {
                      return (
                        <tr
                          key={u.codigo}
                          style={{ cursor: 'pointer', backgroundColor: u.status === 1 ? '#fff5f5' : undefined }}
                          onClick={function () { history.push('/usuarios/' + u.codigo); }}
                        >
                          <td>{u.codigo}</td>
                          <td style={{ fontWeight: 600 }}>{u.nome || '-'}</td>
                          <td>{u.email || '-'}</td>
                          <td>{u.nome_usuario || '-'}</td>
                          {/* W-0608: célula Validade formatada DD/MM/YYYY */}
                          <td>{u.data_hora_expiracao ? moment(u.data_hora_expiracao).format('DD/MM/YYYY') : '-'}</td>
                          {/* W-0608: célula Grupo */}
                          <td>{u.nome_grupo || '-'}</td>
                          <td>{(u.departamento && u.departamento.descricao) || '-'}</td>
                          <td className="text-center">
                            {u.status === 1
                              ? <Badge variant="danger">Inativo</Badge>
                              : <Badge variant="success">Ativo</Badge>
                            }
                          </td>
                          {temPermissao && (
                            <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                              {u.status === 1 ? (
                                <Button
                                  size="sm"
                                  variant="success"
                                  title="Ativar"
                                  onClick={function (e) { e.stopPropagation(); handleAlterarStatus(u); }}
                                >
                                  <FaCheck />
                                </Button>
                              ) : (
                                <Button
                                  size="sm"
                                  variant="warning"
                                  title="Inativar"
                                  onClick={function (e) { e.stopPropagation(); handleAlterarStatus(u); }}
                                >
                                  <FaBan />
                                </Button>
                              )}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="usuarios-mobile p-2">
                {dadosPaginados.map(function (u) {
                  return (
                    <Card
                      key={u.codigo}
                      className="mb-2 shadow-sm"
                      style={{ cursor: 'pointer', backgroundColor: u.status === 1 ? '#fff5f5' : undefined }}
                      onClick={function () { history.push('/usuarios/' + u.codigo); }}
                    >
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <div>
                            <strong style={{ fontSize: '0.95rem' }}>{u.nome || '-'}</strong>
                            <br />
                            <small className="text-muted">#{u.codigo} | {u.nome_usuario || '-'}</small>
                          </div>
                          <div>
                            {u.status === 1
                              ? <Badge variant="danger">Inativo</Badge>
                              : <Badge variant="success">Ativo</Badge>
                            }
                          </div>
                        </div>
                        {u.email && <small className="text-muted">{u.email}</small>}
                        {u.depto && <small className="text-muted ml-2">| {u.depto}</small>}
                        {/* W-0608: linhas extras com Validade e Grupo */}
                        {u.data_hora_expiracao && (
                          <div><small className="text-muted">Validade: {moment(u.data_hora_expiracao).format('DD/MM/YYYY')}</small></div>
                        )}
                        {u.nome_grupo && (
                          <div><small className="text-muted">Grupo: {u.nome_grupo}</small></div>
                        )}
                        {(u.departamento && u.departamento.descricao) && (
                          <div><small className="text-muted">Departamento: {u.departamento.descricao}</small></div>
                        )}
                        {temPermissao && (
                          <div className="text-right mt-1">
                            {u.status === 1 ? (
                              <Button
                                size="sm"
                                variant="success"
                                onClick={function (e) { e.stopPropagation(); handleAlterarStatus(u); }}
                              >
                                <FaCheck className="mr-1" /> Ativar
                              </Button>
                            ) : (
                              <Button
                                size="sm"
                                variant="warning"
                                onClick={function (e) { e.stopPropagation(); handleAlterarStatus(u); }}
                              >
                                <FaBan className="mr-1" /> Inativar
                              </Button>
                            )}
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
            </>
          )}
          {dadosFiltrados.length > ITENS_POR_PAGINA && (
            <div className="d-flex justify-content-between align-items-center px-3 py-2" style={{ borderTop: '1px solid #dee2e6' }}>
              <small className="text-muted">
                Página {pagina} de {totalPaginas} ({dadosFiltrados.length} registros)
              </small>
              <div>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  className="mr-1"
                  disabled={pagina <= 1}
                  onClick={function () { setPagina(pagina - 1); }}
                >
                  &laquo; Anterior
                </Button>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  disabled={pagina >= totalPaginas}
                  onClick={function () { setPagina(pagina + 1); }}
                >
                  Próxima &raquo;
                </Button>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>

      {showStatusModal && (function () {
        var estaAtivo = usuarioAlvo && usuarioAlvo.status !== 1;
        return (
          <Modal show={true} onHide={function () { setShowStatusModal(false); }} centered>
            <Modal.Header closeButton>
              <Modal.Title>{estaAtivo ? 'Inativar' : 'Ativar'} Usuário</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Tem certeza que deseja {estaAtivo ? 'inativar' : 'ativar'} o usuário <strong>{usuarioAlvo && usuarioAlvo.nome}</strong>?
              {estaAtivo && (
                <>
                  <br />
                  <small className="text-muted">Esta ação irá inativar o usuário e remover todos os seus vínculos.</small>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={function () { setShowStatusModal(false); }}>Cancelar</Button>
              <Button
                variant={estaAtivo ? 'warning' : 'success'}
                onClick={handleConfirmarAlteracaoStatus}
                disabled={loadingStatus}
              >
                {loadingStatus ? 'Processando...' : (estaAtivo ? 'Inativar' : 'Ativar')}
              </Button>
            </Modal.Footer>
          </Modal>
        );
      }())}
    </Container>
  );
};

export default Usuarios;
